// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__If1lA","row":"Option_row__3Wtfo"};